// extracted by mini-css-extract-plugin
export default {"poweredBy":"poweredBy__c7tVK","poweredByFooter":"poweredByFooter__viVe9"};